import { render, staticRenderFns } from "./d-book-user-reviews-list.vue?vue&type=template&id=51e7f0c6&scoped=true&"
import script from "./d-book-user-reviews-list.vue?vue&type=script&lang=js&"
export * from "./d-book-user-reviews-list.vue?vue&type=script&lang=js&"
import style0 from "./d-book-user-reviews-list.vue?vue&type=style&index=0&id=51e7f0c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e7f0c6",
  null
  
)

export default component.exports